module.exports = __webpack_public_path__ + "img/ps.49dd74a6.svg";